import * as React from 'react';
import { ActivityItem, IActivityItemProps, Link, Text } from '@fluentui/react';
import { mergeStyleSets } from '@fluentui/merge-styles';
import CircleLoader from '../../../../Loader/CircleLoader/CircleLoader';
import { useEffect, useState } from 'react';
import { IProtocol } from '../../../../../shared/interfaces';
import { reduxActions, RootState } from '../../../../../store';
import { store } from '../../../../../index';
import { useSelector } from 'react-redux';
import Utilities from '../../../../../shared/Utilities/utilities';
import printAndSendService from '../../../../../services/printAndSend.service';
import { Accordion, AccordionTab } from 'primereact/accordion';
import PrintAndSendWizard from './PrintAndSendWizard';
import { Paginator } from 'primereact/paginator';
import abilityBuild from '../../../../../shared/CASL/appAbility';
import axios, { CancelTokenSource } from 'axios';


const activityItemClassNames = mergeStyleSets({
    exampleRoot: {
        paddingBottom: '20px',
    },
    nameText: {
        fontWeight: 'bold',
    },
});


let citta = "Citt%C3%A0";

export interface SEIProps {
    protocol?: IProtocol,
    extraCssClass?: string,
}

const SEI: React.FunctionComponent<SEIProps> = (props) => {


    let cancelTokenSources = {};

    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);
    const selectCurrentUor = (state: RootState) => state.sessionReducer.currentUor;
    const currentUor = useSelector(selectCurrentUor);
    const selectActiveAccordionIndex = (state: RootState) => state.printAndSendWizardReducer.activeAccordionIndex;
    const activeAccordionIndex = useSelector(selectActiveAccordionIndex);



    const [pageSize, setPageSize] = useState(5);
    const [content, setContent] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loadingPrintAndSendList, setLoadingPrintAndSendList] = useState(false);
    const [loadingPrintAndSendForm, setLoadingPrintAndSendForm] = useState(false);

    const [activityItems, setActivityItems] = useState<any[]>([]);
    const [spedizioni, setSpedizioni] = useState<any[]>([]);

    const indexOfLastItem = currentPage * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;

    const onContentPageChange = (event) => {

        let currPage = event.page + 1;
        setCurrentPage(currPage);

        //Per caricare gli item per pagina e visualizzare il loader
        if (event.first === event.first || event.first < event.first) {

            setLoadingPrintAndSendList(true);
            setActivityItems([]);
        }

        setContent(event.first);
    }

    useEffect(() => {
        let currentActivityItems = spedizioni.slice(indexOfFirstItem, indexOfLastItem);
        let activities: any[] = [];

        currentActivityItems.forEach(el => {

            let item: IActivityItemProps = {
                activityDescription: [
                    <Link key={1} className={activityItemClassNames.nameText}>{el.nomeUtenteSpedizione}</Link>,
                    <div key={2}><b>Mittente:</b> {el.nomeMittente}</div>,
                    <div key={3}><b>Destinatario:</b> {el.nomeDestinatario}</div>,
                    <div key={4}><b>Indirizzo destinatario:</b> {el.indirizzoDestinatario}</div>,
                    <div key={5}><b>Documento:</b> {el.nomeDocumento.replace(".pdf", "")}</div>,
                    <div key={6}><b>Stato Spedizione:</b> {el.statoSpedizione}</div>,
                ],
                timeStamp: getActivityTimeStamp(el.data)
            };

            activities.push({ key: el.mpxSetId, ...item });

        });

        setActivityItems(activities);
        setLoadingPrintAndSendList(false);

    }, [spedizioni, currentPage])

    useEffect(() => {
        setLoadingPrintAndSendList(true);

        if (currentAoo) {

            // se in cancelTokenSources c'� il cancelToken associato alla chiamata
            // chiamo il metodo cancel che interrompe la chiamata in pending
            cancelTokenSources[printAndSendService.getPrintAndSendList.name]?.cancel("Request annullata");
            // Ricreo il cancel token ad ogni request
            cancelTokenSources[printAndSendService.getPrintAndSendList.name] = axios.CancelToken.source();


            printAndSendService.getPrintAndSendList(currentAoo.id!, currentUor!.id!, props.protocol!.id!, cancelTokenSources[printAndSendService.getPrintAndSendList.name].token)
                .then(response => {
                    let spedizioni = [...response];
                    setSpedizioni([...response]);

                    let mPXSetIdArray: string[] = [];
                    setTotalRecords(response.length);

                    spedizioni.forEach(el => {

                        if (el.statoSpedizione !== "Completato" && el.statoSpedizione !== "Annullato") {

                            mPXSetIdArray.push(el.mpxSetId);
                        }

                    });

                    //Check sullo stato delle spedizioni per aggiornarle
                    printAndSendService.checkStatusMultiplo(currentAoo.id!, currentUor!.id!, mPXSetIdArray)
                        .then(status => {

                            let mPXSetId;
                            let statoSpedizione;

                            let newSpedizioniToUpdate = [...spedizioni];
                            let entries = Object.entries(status);

                            entries.forEach(([k, value]) => {

                                mPXSetId = k;
                                statoSpedizione = value;

                                let itemIndex = newSpedizioniToUpdate.findIndex(i => i.mpxSetId === mPXSetId);
                                let spedizioneToUpdate = { ...newSpedizioniToUpdate[itemIndex] };

                                if (itemIndex >= 0) {

                                    spedizioneToUpdate.statoSpedizione = statoSpedizione;
                                    newSpedizioniToUpdate[itemIndex] = spedizioneToUpdate;

                                }

                                setSpedizioni(newSpedizioniToUpdate);

                            });

                        })

                    setLoadingPrintAndSendList(false);
                })

        }

    }, [currentAoo]);

    useEffect(() => {

        if (currentAoo && activeAccordionIndex == 0) {
            setLoadingPrintAndSendList(true);

            // il cancelToken risulta diverso da null se la request � in pending in tal caso annullo la vecchia request 
            // Verificare meglio
            if (!cancelTokenSources[printAndSendService.getPrintAndSendList.name]) {

                // Ricreo il cancel token ad ogni request
                cancelTokenSources[printAndSendService.getPrintAndSendList.name] = axios.CancelToken.source();

                printAndSendService.getPrintAndSendList(currentAoo.id!, currentUor!.id!, props.protocol!.id!, cancelTokenSources[printAndSendService.getPrintAndSendList.name].token)
                    .then(response => {
                        let spedizioni = [...response];
                        setSpedizioni([...response]);

                        let mPXSetIdArray: string[] = [];
                        setTotalRecords(response.length);

                        spedizioni.forEach(el => {

                            if (el.statoSpedizione !== "Completato" && el.statoSpedizione !== "Annullato") {

                                mPXSetIdArray.push(el.mpxSetId);
                            }

                        });

                        setLoadingPrintAndSendList(false);
                    })
            }
        }

    }, [activeAccordionIndex]);


    const getActivityTimeStamp = (date: Date) => {
        return Utilities.FormatDate(date, false);
    };

    const canUserSeeAllAccordion = () => {

        let canUserSeeAllAccordion = abilityBuild.can("send", "IPrintAndSend");
        return canUserSeeAllAccordion;
    }
    const renderSpedizioniTable = () => {
        if (activityItems && activityItems.length > 0) {
            return (
                <React.Fragment>
                    {activityItems.map((item) => (
                        <ActivityItem {...item} key={item.key} className={activityItemClassNames.exampleRoot} />
                    ))}
                    {activityItems.length > pageSize &&
                        <Paginator first={content} rows={pageSize} totalRecords={totalRecords} onPageChange={onContentPageChange}></Paginator>
                    }
                </React.Fragment>
            )
        }
        else {
            return (
                <Text block style={{ padding: 25 }}>Non ci sono spedizioni.</Text>
            )
        }
    }

    return (
        <div className={`print-and-send flex flex-column position-relative ${props.extraCssClass}`}>

            <div className={`position-relative my-scroll-div`}>
                <div className={`my-component-content`}>


                    <Accordion activeIndex={activeAccordionIndex} onTabChange={(e) => store.dispatch(reduxActions.printAndSendWizardActions.setActiveAccordionIndex(e.index))}>
                        <AccordionTab header="Spedizioni">
                            <div className={`position-relative my-scroll-div`}>
                                {loadingPrintAndSendList &&
                                    <div className="print-and-send-loader-container" style={{ margin: '15px', position: 'relative', height: '90px' }}>
                                        <CircleLoader loaderClass='loader-large' loading={loadingPrintAndSendList} />
                                    </div>
                                }

                                {!loadingPrintAndSendList && renderSpedizioniTable()}

                            </div>
                        </AccordionTab>

                        {canUserSeeAllAccordion() === true &&

                            <AccordionTab header="Stampa e Invia">
                                <div className={`position-relative my-scroll-div`}>
                                    {loadingPrintAndSendForm &&
                                        <div className="print-and-send-loader-container" style={{ margin: '15px', position: 'relative', height: '90px' }}>
                                            <CircleLoader loaderClass='loader-large' loading={loadingPrintAndSendForm} />
                                        </div>
                                    }
                                    <PrintAndSendWizard protocol={props.protocol} />
                                </div>
                            </AccordionTab>
                        }

                    </Accordion>

                </div>
           </div>
        </ div>

    );
};

export default SEI;
